module.exports = __webpack_public_path__ + "fonts/Graphik-Medium.4a15af1.woff2";